module.exports = __webpack_public_path__ + "img/demo.d7ab217c.png";